
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/icons/courses/[courseSlug]",
      function () {
        return require("private-next-pages/icons/courses/[courseSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/icons/courses/[courseSlug]"])
      });
    }
  